import styled, {css} from 'styled-components'

export const StyledPatientContactsDetailsGrid = styled.div(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-areas: 'icon label' 'icon value';
        grid-template-columns: auto 1fr;
        align-items: center;
        row-gap: ${spacing * 0.5}px;
        column-gap: ${spacing}px;
    `
)
